import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api.js';

const ENTITIES_KEY = ['admin', 'entities'];

export function useEntitiesAdmin() {
  return useQuery({
    queryKey: ENTITIES_KEY,
    queryFn: () => api.get('/admin/entities'),
    staleTime: 30_000,
  });
}

export function useEntityAdmin(id) {
  return useQuery({
    queryKey: ['admin', 'entities', id],
    queryFn: () => api.get(`/admin/entities/${id}`),
    staleTime: 30_000,
    enabled: Boolean(id),
  });
}

function useEntityMutation(mutateFn) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: mutateFn,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ENTITIES_KEY });
    },
  });
}

export function useCreateEntity() {
  return useEntityMutation((body) => api.post('/admin/entities', body));
}

export function useUpdateEntity() {
  return useEntityMutation(({ id, ...body }) => api.patch(`/admin/entities/${id}`, body));
}

// Soft delete — backend sets status='archived'
export function useDeleteEntity() {
  return useEntityMutation((id) => api.delete(`/admin/entities/${id}`));
}
